import { Pill } from '@scoir/pills'

const ActiveCell = ({ record }: any) => {
  if (record.NeedsApproval) {
    return <Pill color="warning">Pending Approval</Pill>
  }
  return record.Active ? <Pill color="success">Active</Pill> : <Pill>Inactive</Pill>
}

export default ActiveCell
